import styled from '@emotion/styled';
import { Input } from 'antd';
export const VerticalOffset = styled.div `
  position: relative;
  top: ${({ pixels }) => `${pixels}px`};
`;
export const EmailInput = styled(Input) `
  width: 500px;
`;
export const EmailInputError = styled.div `
  visibility: ${({ errorText }) => (errorText ? 'visible' : 'hidden')};
  position: absolute;
  color: red;
  top: -22px;
`;
//# sourceMappingURL=styled.js.map